import React from "react";

const ChangeCandidatePayIcon = ({ cls }) => {
  return (
    <svg
      fill="currentColor"
      height="800px"
      width="800px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      className={cls}
    >
      <g>
        <g>
          <path
            d="M354.338,34.205h-61.71c-3.354-9.93-12.752-17.102-23.8-17.102h-17.547C243.359,6.451,230.813,0,217.521,0
           s-25.839,6.451-33.76,17.102h-17.547c-11.048,0-20.446,7.172-23.8,17.102H80.701c-18.566,0-33.67,15.105-33.67,33.67v359.148
           c0,18.566,15.105,33.67,33.67,33.67h171.023c4.427,0,8.017-3.589,8.017-8.017c0-4.427-3.589-8.017-8.017-8.017H80.701
           c-9.725,0-17.637-7.912-17.637-17.637V67.875c0-9.725,7.912-17.637,17.637-17.637h60.394v26.188c0,4.427,3.589,8.017,8.017,8.017
           H285.93c4.427,0,8.017-3.589,8.017-8.017V50.238h60.391c9.725,0,17.637,7.912,17.637,17.637v230.881
           c0,4.427,3.589,8.017,8.017,8.017c4.427,0,8.017-3.589,8.017-8.017V67.875C388.008,49.309,372.904,34.205,354.338,34.205z
            M277.914,68.409H157.129V42.252c0-0.011,0.001-0.02,0.001-0.031c0-0.005-0.001-0.011-0.001-0.015
           c0.009-5.004,4.08-9.071,9.085-9.071h21.846c2.854,0,5.493-1.517,6.929-3.985c4.781-8.213,13.204-13.117,22.532-13.117
           s17.751,4.904,22.532,13.117c1.435,2.467,4.075,3.985,6.929,3.985h21.846c4.999,0,9.067,4.059,9.085,9.055
           c0,0.011-0.001,0.02-0.001,0.031c0,0.021,0.003,0.041,0.003,0.062V68.409z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M251.722,410.455H97.269V84.443h17.64c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017H89.253
           c-4.427,0-8.017,3.589-8.017,8.017v342.046c0,4.427,3.589,8.017,8.017,8.017h162.47c4.427,0,8.017-3.589,8.017-8.017
           C259.739,414.044,256.15,410.455,251.722,410.455z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M345.787,68.409h-25.653c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.637v214.311
           c0,4.427,3.589,8.017,8.017,8.017s8.017-3.589,8.017-8.017V76.426C353.804,71.999,350.214,68.409,345.787,68.409z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M371.44,324.944c-51.572,0-93.528,41.956-93.528,93.528S319.869,512,371.44,512s93.528-41.956,93.528-93.528
           S423.012,324.944,371.44,324.944z M371.44,495.967c-42.731,0-77.495-34.764-77.495-77.495s34.764-77.495,77.495-77.495
           s77.495,34.764,77.495,77.495S414.172,495.967,371.44,495.967z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M217.607,34.205h-0.086c-4.427,0-7.974,3.589-7.974,8.017c0,4.427,3.631,8.017,8.059,8.017
           c4.427,0,8.017-3.589,8.017-8.017C225.624,37.794,222.035,34.205,217.607,34.205z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M419.865,387.15c-3.13-3.131-8.207-3.131-11.337,0l-54.19,54.19l-28.536-28.536c-3.131-3.131-8.207-3.131-11.337,0
           c-3.131,3.131-3.131,8.207,0,11.337l34.205,34.205c1.565,1.565,3.617,2.348,5.668,2.348s4.103-0.782,5.668-2.348l59.858-59.858
           C422.995,395.356,422.995,390.28,419.865,387.15z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M182.781,177.309v-32.338c11.295,1.934,18.171,7.688,18.171,11.889c0,4.427,3.589,8.017,8.017,8.017
           s8.017-3.589,8.017-8.017c0-14.171-14.492-25.621-34.205-28.092v-1.036c0-4.427-3.589-8.017-8.017-8.017s-8.017,3.589-8.017,8.017
           v1.036c-19.713,2.47-34.205,13.92-34.205,28.092c0,20.074,18.829,27.788,34.205,32.461v32.338
           c-11.295-1.934-18.171-7.688-18.171-11.889c0-4.427-3.589-8.017-8.017-8.017s-8.017,3.589-8.017,8.017
           c0,14.171,14.492,25.621,34.205,28.092v1.036c0,4.427,3.589,8.017,8.017,8.017s8.017-3.589,8.017-8.017v-1.036
           c19.713-2.47,34.205-13.92,34.205-28.092C216.985,189.697,198.157,181.982,182.781,177.309z M166.747,172.411
           c-13.524-4.713-18.171-8.963-18.171-15.551c0-2.535,2.236-5.335,6.134-7.68c3.294-1.982,7.473-3.415,12.037-4.198V172.411z
            M194.818,217.45c-3.294,1.982-7.473,3.415-12.037,4.198v-27.429c13.524,4.713,18.171,8.963,18.171,15.551
           C200.952,212.306,198.716,215.105,194.818,217.45z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M294.48,136.818h-42.756c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h42.756
           c4.427,0,8.017-3.589,8.017-8.017S298.908,136.818,294.48,136.818z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M277.378,171.023h-25.653c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h25.653
           c4.427,0,8.017-3.589,8.017-8.017S281.805,171.023,277.378,171.023z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M294.48,205.228h-42.756c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h42.756
           c4.427,0,8.017-3.589,8.017-8.017S298.908,205.228,294.48,205.228z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M157.662,282.188H140.56c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102
           c4.427,0,8.017-3.589,8.017-8.017S162.089,282.188,157.662,282.188z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M157.662,350.597H140.56c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102
           c4.427,0,8.017-3.589,8.017-8.017S162.089,350.597,157.662,350.597z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M157.662,316.393H140.56c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102
           c4.427,0,8.017-3.589,8.017-8.017S162.089,316.393,157.662,316.393z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M294.48,282.188H191.866c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017H294.48
           c4.427,0,8.017-3.589,8.017-8.017S298.908,282.188,294.48,282.188z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M268.827,350.597h-76.96c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h76.96
           c4.427,0,8.017-3.589,8.017-8.017S273.254,350.597,268.827,350.597z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M294.48,316.393H191.866c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017H294.48
           c4.427,0,8.017-3.589,8.017-8.017S298.908,316.393,294.48,316.393z"
          />
        </g>
      </g>
    </svg>
  );
};

export default ChangeCandidatePayIcon;
